import * as React from 'react';

import PropTypes from 'prop-types';
import { compose } from 'underscore';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import _t from 'i18n!nls/discussions';

class SessionDetails extends React.Component {
  static propTypes = {
    hasSession: PropTypes.bool,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasSession' does not exist on type 'Read... Remove this comment to see the full error message
    const { hasSession } = this.props;

    if (!hasSession) {
      return null;
    }

    return (
      <div className="rc-SessionDetails mentor-message align-horizontal-center">
        {_t('This thread is visible to all learners.')}
      </div>
    );
  }
}

export default compose(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type '{}'.
  connectToStores(['SessionFilterStore'], ({ SessionFilterStore }, { question }) => {
    const questionSession =
      SessionFilterStore.allSessions &&
      SessionFilterStore.allSessions.find((session: $TSFixMe) => session.id === question.sessionId);

    return {
      hasSession: !!questionSession,
    };
  })
)(SessionDetails);
